import { allowedContentTypes, type ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';

import type {
  CreateMediaData,
  CreateMediaRequest,
  CreateUploadUrlRequest,
} from './schema';

const contentTypeSchema = yup.string().required().oneOf(allowedContentTypes);
const titleSchema = yup.string().required();

export const createUploadUrlRequestSchema = yup.object<
  ObjectType<CreateUploadUrlRequest>
>({
  title: titleSchema,
  contentType: contentTypeSchema,
});

export const createMediaDataSchema = yup.object<ObjectType<CreateMediaData>>({
  title: titleSchema,
  contentType: contentTypeSchema,
  key: yup.string().required(),
});

// don't allow more than 5 medias to be created at once
export const createMediaRequestSchema = yup.object<
  ObjectType<CreateMediaRequest>
>({
  media: yup.array(createMediaDataSchema).required().min(1).max(5),
});
